import React from "react";
//outsource
import { DatePicker } from "antd";

//components

//redux
import { useDispatch, useSelector } from "react-redux";
import { setTo } from "../../../../store/report/report.action";
import { from, to } from "../../../../store/report/report.selector";

const formatDate = "DD/MM/YYYY";

const TimeTo = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const dataFrom = useSelector(from);
  const dataTo = useSelector(to);
  // -------------------------- FUNCTION --------------------------
  const handleChange = (to) => {
    dispatch(setTo({ data: to }));
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      defaultValue={dataTo}
      disabledDate={(current) => {
        return current && current <= dataFrom;
      }}
      style={{ width: "100%" }}
      placeholder="To Date"
      format={formatDate}
      disabled={disabled}
      onChange={handleChange}
      allowClear={false}
    />
  );
};

export default TimeTo;
